import React from 'react';

const SettingsPassword = ({ userData }) => (
  <form className="box box--has-border" action="#">
    <div className="columns-sm">
      <div className="form-group">
        <label>Name</label>
        <input
          type="text"
          required
          name="name"
          placeholder="Your Name"
          autoComplete="name"
        />
      </div>

      <div className="form-group">
        <label>Last Name</label>
        <input
          type="text"
          required
          name="last-name"
          placeholder="Your Last Name"
          autoComplete="lname"
        />
      </div>
    </div>
    <div className="form-group">
      <label>Email Address</label>
      <input
        type="text"
        required
        name="email"
        placeholder="Enter your email here"
        autoComplete="email"
      />
    </div>

    <div className="form-group">
      <label>Language</label>
      <select name="language">
        <option value="" disabled selected>
          Select language
        </option>
        <option value="en">English</option>
        <option value="es">Spanish</option>
      </select>
    </div>
    <button className="btn-primary is-block" type="submit">
      Save
    </button>
  </form>
);

export default SettingsPassword;
